import { logoutClientsApp } from '../duck/legado/clientsApp';
import { logoutBoletosFaresApp } from '../duck/legado/faresApp/boletosFares';
import { logoutIncomeFaresApp } from '../duck/legado/faresApp/Income';
import { logoutMonthlyFaresApp } from '../duck/legado/faresApp/monthlyFares';
import { logoutSlbFaresApp } from '../duck/legado/faresApp/slbFares';
import { logoutTedFaresApp } from '../duck/legado/faresApp/tedFares';
import { logoutOutstandingDebitsApp } from '../duck/legado/outstandingDebitsApp';
import { logoutAction } from '../duck/loginPage/loginAuth';

export function SendLoginTokenAuth() {
  const token = localStorage.getItem('loginToken');

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  return config;
}

export function Logout() {
  return (dispatch: any) => {
    localStorage.clear();
    dispatch(logoutAction());
    dispatch(logoutClientsApp());
    dispatch(logoutBoletosFaresApp());
    dispatch(logoutSlbFaresApp());
    dispatch(logoutMonthlyFaresApp());
    dispatch(logoutTedFaresApp());
    dispatch(logoutIncomeFaresApp());
    dispatch(logoutOutstandingDebitsApp());
  };
}
